import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "d-flex align-items-center justify-content-center gap-2" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "fas fa-edit" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_Search = _resolveComponent("Search")!
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_InnerLoader, { loading: _ctx.loading }, null, 8, ["loading"]),
    _createVNode(_component_Search, {
      selectData: _ctx.filterObject,
      filter: true,
      clearInput: true,
      clearInputSelect: true,
      showExport: false,
      showButton: true,
      filterPlaceholder: 'message.SELECT',
      inputPlaceholder: "message.ENTER_KEY_TO_SEARCH",
      onSearch: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchHandler(1, Number(_ctx.routeParam)))),
      onReloadListing: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getProductGroupAssignmentProducts(1, false, null, null, Number(_ctx.routeParam))))
    }, null, 8, ["selectData", "filterPlaceholder"]),
    _createVNode(_component_Table, {
      columns: _ctx.columns,
      rows: _ctx.productsData,
      pagination: _ctx.pagination,
      padding: 3,
      onHandleCurrentChange: _ctx.handleCurrentChange,
      loading: _ctx.loader,
      onSorting: _ctx.searchHandler
    }, {
      "cell-name": _withCtx(({ row: item }) => [
        _createTextVNode(_toDisplayString(JSON.parse(item.name.name)[`${_ctx.system_locale}`]?.name), 1)
      ]),
      "cell-sale_price": _withCtx(({ row: item }) => [
        _createTextVNode(_toDisplayString(item.sale_price), 1)
      ]),
      "cell-discount": _withCtx(({ row: item }) => [
        _createVNode("div", _hoisted_2, [
          (_ctx.hasGroupDiscount(item))
            ? (_openBlock(), _createBlock("span", _hoisted_3, _toDisplayString(_ctx.formatDiscountType(item.discount_type)) + ": " + _toDisplayString(item.discount_value), 1))
            : (_openBlock(), _createBlock("span", _hoisted_4, "-")),
          _createVNode("button", {
            type: "button",
            class: "btn btn-sm btn-icon btn-light-primary",
            onClick: ($event: any) => (_ctx.handleEditDiscount(item))
          }, [
            _hoisted_5
          ], 8, ["onClick"])
        ])
      ]),
      _: 1
    }, 8, ["columns", "rows", "pagination", "onHandleCurrentChange", "loading", "onSorting"])
  ]))
}